import { useGameState } from '@/pages/dsst-spick/hooks/useGameState';
import { useViewportMetrics } from '@/pages/dsst-spick/hooks/useViewportMetrics';
import TopBar from '@/pages/dsst-spick/components/TopBar';
import GuideScreen from '@/pages/dsst-spick/components/GuideScreen';
import CountdownScreen from '@/pages/dsst-spick/components/CountdownScreen';
import GameScreen from '@/pages/dsst-spick/components/GameScreen';
import ResultScreen from '@/pages/dsst-spick/components/ResultScreen';
import ExitConfirmModal from '@/pages/dsst-spick/components/ExitConfirmModal';

// 스픽(Spick) 인앱용 기호 맞추기 (DSST) 버전
// 플로우: 게임 소개 → 카운트다운 → 본게임(총 45초 단일 스테이지) → 결과
// 연습 단계/스테이지 구분 없음. 5연속 정답마다 기호 그룹이 교체된다.
// 화면 구성과 스타일은 Spatial Span 스픽 버전과 동일한 시스템을 사용한다.
export default function DsstSpick() {
  // 실제 가용 높이를 측정해 CSS 변수(--sh-app-height 등)로 주입한다
  useViewportMetrics();

  const {
    screen,
    symbolMap,
    symbolSetIndex,
    currentSymbol,
    selectedNumber,
    feedback,
    remainingSeconds,
    score,
    totalQuestions,
    correctCount,
    combo,
    setChangeNotice,
    numberOrder,
    showExitModal,
    startGame,
    handleCountdownComplete,
    handleGameSelect,
    goToGuide,
    openExitModal,
    closeExitModal,
    confirmExit,
    retryGame,
    goToNext,
  } = useGameState();

  const isPlaying = screen === 'game';
  // 게임 소개(진입) 화면에서는 상단바를 렌더링하지 않는다
  const isEntry = screen === 'guide';
  // 결과 화면은 연블루 그라데이션 배경을 사용한다 (상단바 영역까지 이어짐)
  const isResult = screen === 'result';

  // WebView 네비게이션과 충돌하지 않도록 게임 정보 없이 뒤로/홈만 배치
  const handleBack = () => {
    if (isPlaying) {
      openExitModal();
      return;
    }
    goToGuide();
  };

  const handleHome = () => {
    if (isPlaying) {
      openExitModal();
      return;
    }
    goToGuide();
  };

  return (
    <div className="spick-scope dsst-spick-scope w-full bg-white flex justify-center">
      <div
        className={`w-full max-w-[430px] flex flex-col relative overflow-hidden game-no-scroll ${
          isResult ? 'sh-result-bg' : 'bg-white'
        }`}
        /* 100dvh 기준: 브라우저 주소창/하단 메뉴가 바뀌어도 실제 가용 높이를 사용한다. */
        style={{ height: 'var(--sh-app-height, 100dvh)' }}
      >
        {!isEntry && (
          <TopBar
            onBack={handleBack}
            onHome={handleHome}
            /* 게임 화면에서는 헤더부터 하단까지 BG 컬러 레이어가 이어져야 하고,
               결과 화면에서는 그라데이션 배경이 상단바 뒤로 이어지도록 투명 처리 */
            backgroundClassName={isPlaying ? 'sh-game-bg' : isResult ? 'bg-transparent' : 'bg-white'}
          />
        )}

        <div className="flex-1 min-h-0 overflow-hidden">
          {screen === 'guide' && (
            <GuideScreen onStart={startGame} setIndex={symbolSetIndex} />
          )}
          {screen === 'countdown' && (
            <CountdownScreen onComplete={handleCountdownComplete} />
          )}
          {screen === 'game' && (
            <GameScreen
              symbolMap={symbolMap}
              currentSymbol={currentSymbol}
              selectedNumber={selectedNumber}
              feedback={feedback}
              remainingSeconds={remainingSeconds}
              combo={combo}
              setChangeNotice={setChangeNotice}
              setIndex={symbolSetIndex}
              numberOrder={numberOrder}
              onSelect={handleGameSelect}
            />
          )}
          {screen === 'result' && (
            <ResultScreen
              score={score}
              correctCount={correctCount}
              totalQuestions={totalQuestions}
              onRetry={retryGame}
              onNext={goToNext}
            />
          )}
        </div>

        <ExitConfirmModal
          isOpen={showExitModal}
          onConfirm={confirmExit}
          onCancel={closeExitModal}
        />
      </div>
    </div>
  );
}